import { render, staticRenderFns } from "./customer-history.vue?vue&type=template&id=c633bda8&scoped=true"
import script from "./customer-history.vue?vue&type=script&lang=js"
export * from "./customer-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c633bda8",
  null
  
)

export default component.exports